
import Vue from 'vue'
import { showToast } from '@/utilities/Utils'
import i18n from '@/locales/_i18n';

import { keyAccountFormatServer } from "./keyAccountFormatServer";

const getDefaultState = () => {
    return {
        keyAccount: {
            id: 0,
            dataCadastro: "",
            idUsuarioCadastro: 0,
            status: 1,
            idCliente: 0
        }
    }
};

const state = getDefaultState();

const actions = {

    resetState({ commit }) {
        commit('resetState');
    },

    saveState({ commit }, payload) {
        commit('saveState', payload);
    },

    async List() {

        try {
            const result = await Vue.prototype.$spTechApi.get("keyAccount/list",
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                let listkeyAccount = result.data.result;

                return listkeyAccount;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Erro ao carregar key accounts: [${ex}]`
            };
        }
    },

    async GetById(_, id) {

        try {
            const result = await Vue.prototype.$spTechApi.get(`keyAccount/${id}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200) {
                return result.data;
            }
            else {
                return {
                    success: false,
                    result: `Erro ao obter keyAccount`
                };
            }
        }
        catch(error) {

            if (error.response && error.response.status === 400) {
                showToast("error", this.$t('erro'), error.response.data);
            }
            else {
                showToast("error", this.$t('erro'), error);
            }
        }
    },

    async CreateUpdate(_, keyAccountRequest) {

        try {
            let keyAccountRequestFormatted = keyAccountFormatServer(keyAccountRequest);

            const result = await Vue.prototype.$spTechApi.post(`keyAccount/create-update`, keyAccountRequestFormatted,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 200) {

                let msg = "Registro atualizado com sucesso!";

                if (keyAccountRequest.id === 0) {
                    msg = "Registro criado com sucesso!";
                }

                return {
                    success: true,
                    idkeyAccount: result.data.result,
                    message: msg
                };
            }
            else {
                return {
                    success: false,
                    message: `${i18n.t('erroCriarAtualizarRegistro')}`
                };
            }
        }
        catch(error) {

            if (error.response && error.response.status === 400) {
                return {
                    success: false,
                    message: `${i18n.t('erroCriarAtualizarRegistro')}: [${error.response.data}]`
                };
            }
            else {

                return {
                    success: false,
                    message: `${i18n.t('erroCriarAtualizarRegistro')}: [${error}]`
                };
            }
        }
    },

    async AlterarStatus(_, { id, statusId }) {

        try {
            const result = await Vue.prototype.$spTechApi.put(`keyAccount/update-status/${id}/${statusId}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.status === 204) {
                return {
                    success: true,
                    message: "key account atualizada com sucesso!"
                };
            }
            else {
                return {
                    success: false,
                    message: "Erro ao atualizar o status!"
                };
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Erro ao atualizar o status: [${ex}]`
            };
        }
    },

    async ListarProdutos(_, idCliente) {

        try {
            const result = await Vue.prototype.$spTechApi.get(`keyAccount/listar-produtos/${idCliente}`,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                let listProdutos = result.data.result;

                return listProdutos;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Erro ao carregar produtos do key account: [${ex}]`
            };
        }
    },
}

const mutations = {

    saveState: (state, newValue) => {
        Object.assign(state.keyAccount, newValue);
    },

    resetState: (state) => {
        Object.assign(state, getDefaultState());
    }
}

const getters = {

    searchState: (state) => {
        return state.keyAccount;
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
